import Client from './client';

export default class FraudProviderConfigurations extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  getDefault(organization, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/fraud/providers/default`, options);
  }

  putDefault(organization, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/fraud/providers/default`, {
      ...options,
       method: 'PUT',
    });
  }

  deleteDefault(organization, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/fraud/providers/default`, {
      ...options,
       method: 'DELETE',
    });
  }

}
